module.exports = __webpack_public_path__ + "static/media/pcc-logo-black.bee18b75.svg";